import Swiper from 'swiper/dist/js/swiper';

export default ($el) => {
  const updatesSwiper = new Swiper(
    $el.find('.swiper-container'),
    {
      autoHeight: true,
      navigation: {
        disabledClass: 'cursor-default opacity-50',
        nextEl: $el.find('.js-updates-swiper-next'),
        prevEl: $el.find('.js-updates-swiper-prev'),
      },
    },
  );

  updatesSwiper.on('slideChange', () => {
    updateActiveSlideNumber();
    pauseAllVideos();
  });

  const updateActiveSlideNumber = () => {
    const activeSlideNumber = updatesSwiper.activeIndex + 1;
    $el.find('.js-active-slide-number').text(activeSlideNumber);
  };

  const pauseAllVideos = () => {
    window.reactPlayers.forEach((reactPlayer) => {
      const player = reactPlayer.getInternalPlayer();
      player.pause();
    });
  };
};
